import React, { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import cn from 'classnames'

import Navbar from '../containers/Navbar'
import OrdersList from '../components/orders/List'
import OrdersSidebar from '../containers/orders/Sidebar'
import TopNav from '../containers/orders/TopNav'

import styles from './Orders.module.scss'

import Button from '../components/Button'

import { clearOrderInProgress, clearSelectedOrder, tabOrdersRequested } from '../actions/order'

import { getTabsModeEnabled } from '../selectors/menus'
import { setSyncWarningDialog } from '../VNDialogs/ActionCreators'

import { getIsSyncing } from '../VNSyncManager/Selectors'
import useGetIsMobileScreen from '../hooks/useGetIsMobileScreen'

const Orders = ({ className }) => {
  const classNames = cn(styles.orders, className)
  const history = useHistory()
  const dispatch = useDispatch()
  const isMobile = useGetIsMobileScreen()
  const isSyncInProgress = useSelector(getIsSyncing)
  const tabsModeEnabled = useSelector(getTabsModeEnabled)

  const onNewOrderClick = () => {
    const newOrderCallback = () => {
      dispatch(clearOrderInProgress())
      history.push('/concession-order')
    }

    if (isSyncInProgress) {
      dispatch(setSyncWarningDialog(true, newOrderCallback))
      return
    }

    newOrderCallback()
  }

  useEffect(() => {
    if (tabsModeEnabled) {
      dispatch(tabOrdersRequested())
    }
  }, [tabsModeEnabled, dispatch])

  useEffect(() => {
    return () => {
      dispatch(clearSelectedOrder())
    }
  })

  return (
    <div className={classNames}>
      <Navbar className={styles.navbar} />
      <div className={styles.content}>
        <div className={styles.ordersContainer}>
          {isMobile && <TopNav className={styles.header} />}
          <div className={styles.row}>
            <div className={styles.col1}>
              <OrdersList />
            </div>
            <div className={styles.col2}>
              <OrdersSidebar />
            </div>
          </div>
        </div>
        <div className={styles.mobileBtnContainer}>
          <Button useMui className={styles.mobileOrderBtn} onClickCapture={onNewOrderClick}>
            New Order
          </Button>
        </div>
      </div>
    </div>
  )
}

export default Orders
